// FIXME: Uma página não deveria ter tanto css feito na mão
import { RaiseCard } from "./raise-components"
import styled from "styled-components"

import { colors, WIDTH_BREAKPOINTS } from "./components/globalStyles"
import { SwitchDonateStateful } from "./stateful"

export const Content = styled.div`
  background-color: ${colors.gray3};
  font-family: "Poppins", sans-serif;
  will-change: padding;
  transition: padding ease 1s;
`

export const GridContent = styled.div`
  display: grid;
  grid-gap: 20px;
  grid-template-columns: 1fr 1fr;
  grid-template-areas:
    "header header"
    "left right";
  @media only screen and (max-width: ${WIDTH_BREAKPOINTS.lg}) {
    grid-template-columns: 1fr;
    grid-template-areas:
      "header"
      "left"
      "right";
  }
`

export const Header = styled(RaiseCard)`
  grid-area: header;
  width: 100%;
  .ant-card-body {
    display: flex;
    flex-direction: row;
    align-items: center;
    @media only screen and (max-width: ${WIDTH_BREAKPOINTS.lg}) {
      flex-direction: column;
    }
  }
`

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: space-between;
  align-items: center;
  width: 100%;
  @media only screen and (max-width: ${WIDTH_BREAKPOINTS.lg}) {
    justify-content: center;
    .ant-typography {
      margin-left: 10px !important;
    }
  }
`

export const HeaderRight = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-content: space-between;
  align-items: center;
  width: 100%;
  @media only screen and (max-width: ${WIDTH_BREAKPOINTS.lg}) {
    margin-top: 30px;
    justify-content: center;
  }
`

export const ColLeft = styled.div`
  grid-area: left;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: space-between;
  width: 100%;
`

export const ColRight = styled.div`
  grid-area: right;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-content: space-between;
  width: 100%;
`

export const Card = styled(RaiseCard)`
  .ant-card-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-content: space-between;
  }
  width: 100%;
  margin-bottom: 20px;
`

export const SwitchDonateStyled = styled(SwitchDonateStateful)`
  justify-content: center;
`

export const FormContent = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`
